import React from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import '../../styles/aboutUs-page/impact/ImpactSection.min.css';

const ImpactSection = () => {
    return (
        <Container fluid className="impact-section section-separator p-0 d-flex justify-content-center align-items-center flex-column">
            <div className="about-us-impact w-100 bg-transp d-flex justify-content-start align-items-center p-3 p-md-5 p-lg-5">
                <Col lg={7} md={8} sm={12} className='bg-transp text-start p-0 p-md-5'>
                    <h2 className='fw-bold display-5 bg-transp m-0'>
                        PARA CONSTRUIR UM MUNDO MELHOR, É PRECISO SONHAR, EXPLORAR E AGIR!
                    </h2>   
                </Col>
            </div>
            <Col lg={ 5} md={8} sm={10} className='d-flex justify-content-center py-5 p-3'>
                <p className='text-justify m-0 lead'>
                    Até hoje, já impactámos mais de 12.000 jovens através dos nossos projetos e eventos. Cada iniciativa é um passo em direção a uma sociedade mais participativa, consciente e sustentável.
                </p>
            </Col>
        </Container>
    );
}

export default ImpactSection;
